import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL;

const getAuthHeaders = () => {
  const token = localStorage.getItem("userAccessToken");
  return {
    Authorization: `Bearer ${token}`,
  };
};

export const getPlans = async () => {
  return axios.get(`${API_BASE}/api/subscriptions/plans`, {
    headers: getAuthHeaders(),
  });
};

export const getUserSubscription = async () => {
  return axios.get(`${API_BASE}/api/subscriptions/current`, {
    headers: getAuthHeaders(),
  });
};

export const createOrder = async (planName, billingPeriod = 'monthly', customAmount = null) => {
  return axios.post(
    `${API_BASE}/api/subscriptions/create-order`,
    { 
      plan_name: planName,
      billing_period: billingPeriod,
      amount: customAmount // If provided, use this amount instead of plan default
    },
    {
      headers: getAuthHeaders(),
    }
  );
};

export const verifyPayment = async (paymentData) => {
  return axios.post(
    `${API_BASE}/api/subscriptions/verify-payment`,
    paymentData,
    {
      headers: getAuthHeaders(),
    }
  );
};

export const checkAccess = async (requiredPlan) => {
  return axios.get(`${API_BASE}/api/subscriptions/check-access`, {
    params: { required_plan: requiredPlan },
    headers: getAuthHeaders(),
  });
};

export const getSubscriptionHistory = async () => {
  return axios.get(`${API_BASE}/api/subscriptions/history`, {
    headers: getAuthHeaders(),
  });
};

export const checkFlowAccess = async () => {
  return axios.get(`${API_BASE}/api/subscriptions/check-flow-access`, {
    headers: getAuthHeaders(),
  });
};

export const getAddonPlans = async () => {
  return axios.get(`${API_BASE}/api/subscriptions/addon-plans`, {
    headers: getAuthHeaders(),
  });
};

export const createAddonOrder = async (addonId, billingPeriod = 'monthly') => {
  return axios.post(
    `${API_BASE}/api/subscriptions/create-addon-order`,
    { addon_id: addonId, billing_period: billingPeriod },
    {
      headers: getAuthHeaders(),
    }
  );
};

export const verifyAddonPayment = async (paymentData) => {
  return axios.post(
    `${API_BASE}/api/subscriptions/verify-addon-payment`,
    paymentData,
    {
      headers: getAuthHeaders(),
    }
  );
};

// AI Credit APIs
export const getUserCredits = async () => {
  return axios.get(`${API_BASE}/api/subscriptions/credits`, {
    headers: getAuthHeaders(),
  });
};

export const getCreditPlans = async () => {
  return axios.get(`${API_BASE}/api/subscriptions/credit-plans`, {
    headers: getAuthHeaders(),
  });
};

export const getCreditAddingPlan = async () => {
  return axios.get(`${API_BASE}/api/subscriptions/credit-adding-plan`, {
    headers: getAuthHeaders(),
  });
};

export const createCreditOrder = async (creditPlanId, creditsAmount) => {
  return axios.post(
    `${API_BASE}/api/subscriptions/create-credit-order`,
    { 
      credit_plan_id: creditPlanId,
      credits_amount: creditsAmount,
    },
    {
      headers: getAuthHeaders(),
    }
  );
};

export const verifyCreditPayment = async (paymentData) => {
  return axios.post(
    `${API_BASE}/api/subscriptions/verify-credit-payment`,
    paymentData,
    {
      headers: getAuthHeaders(),
    }
  );
};

